import {
  IEntityCreate,
  IEntityCreateFailure,
  IEntityCreateSuccess,
  IEntityDelete,
  IEntityDeleteFailure,
  IEntityDeleteSuccess,
  IEntityFetch,
  IEntityFetchCollectionFailure,
  IEntityFetchCollectionSuccess,
  IEntityFetchFailure,
  IEntityFetchSuccess,
  IEntityUpdateFailure,
  IEntityUpdateSuccess,
  createEntityActionNames,
} from "store/entities/actions";
import { ActionsUnion, createAction } from "store/helper";

import { ICustomField } from "./interfaces";

export const CUSTOM_FIELD = {
  ...createEntityActionNames("CUSTOM_FIELD"),
};

export const customFieldActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create: (payload: IEntityCreate<ICustomField>) => createAction(CUSTOM_FIELD.CREATE.REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (payload: IEntityCreateSuccess) => createAction(CUSTOM_FIELD.CREATE.SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: IEntityCreateFailure) => createAction(CUSTOM_FIELD.CREATE.FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  delete: (payload: IEntityDelete) => createAction(CUSTOM_FIELD.DELETE.REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSuccess: (payload: IEntityDeleteSuccess) => createAction(CUSTOM_FIELD.DELETE.SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteFailure: (payload: IEntityDeleteFailure) => createAction(CUSTOM_FIELD.DELETE.FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: (payload: IEntityFetch) => createAction(CUSTOM_FIELD.FETCH_SINGLE.REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: (payload: IEntityFetchSuccess<ICustomField>) =>
    createAction(CUSTOM_FIELD.FETCH_SINGLE.SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: IEntityFetchFailure) => createAction(CUSTOM_FIELD.FETCH_SINGLE.FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update: (payload: Partial<ICustomField>) => createAction(CUSTOM_FIELD.UPDATE.REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateSuccess: (payload: IEntityUpdateSuccess) => createAction(CUSTOM_FIELD.UPDATE.SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateFailure: (payload: IEntityUpdateFailure) => createAction(CUSTOM_FIELD.UPDATE.FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollection: () => createAction(CUSTOM_FIELD.FETCH_COLLECTION.REQUEST),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionSuccess: (payload: IEntityFetchCollectionSuccess<ICustomField>) =>
    createAction(CUSTOM_FIELD.FETCH_COLLECTION.SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(CUSTOM_FIELD.FETCH_COLLECTION.FAILURE, payload),
};

export type CustomFieldAction = ActionsUnion<typeof customFieldActions>;
